/**
 * Updates the localization of the current page
 * Country takes precedence over currency
 *
 * https://shopify.dev/docs/themes/markets/localization-discovery#step-2-update-the-current-localization
 */
export const updateLocalization = ({
  countryCode,
  currencyCode,
  returnTo,
}: {
  countryCode?: string;
  currencyCode?: string;
  returnTo?: string;
}) => {
  const formHtml = `
    <form id="awt-localization-form" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">

      <input type="hidden" name="return_to" value="${
        returnTo ? returnTo : window?.location?.href
      }">

      ${countryCode ? `<input name="country_code" value="${countryCode}">` : ''}

      ${
        currencyCode
          ? `<input name="currency_code" value="${currencyCode}">`
          : ''
      }

    </form>
  `;

  document.body.insertAdjacentHTML('beforeend', formHtml);
  (document.getElementById('awt-localization-form') as any).submit();
};
